import React from 'react'
import { CheetSheetTemplate, ProjectTemplate } from '../../index'
import { htmlCss } from '../../../utils/constants'
export default function HtmlCss(props) {

    return (
        <>
            <ProjectTemplate name='HTML CSS' mode={props.mode} isValue={props.isValue} >
                <div className="aboutMe blogDiv">
                {
                        htmlCss.map((category,index)=>(
                            <CheetSheetTemplate
                                key={index}
                                imgClass={category.imgClass}
                                heading={category.heading}
                                headStyle={category.headStyle}
                                des={category.des}
                                url={category.url}
                                divStyle={category.divStyle}
                                img={category.img}
                                headerStyle={category.headerStyle}
                                class={category.class}
                                code={category.code}
                            />
                        ))
                    }
                </div>
            </ProjectTemplate>
        </>
    )
}
